const PARAM_W = 'min_piece_w';
const PARAM_L = 'min_piece_l';
const PARAM_T = 'min_piece_t';
const MIN_EPS = 1e-5;

function parseProductDimension(v) {
  if (v == null) return NaN;
  if (typeof v === 'number') return Number.isFinite(v) ? v : NaN;
  const t0 = String(v).trim();
  if (!t0) return NaN;
  if (t0[0] === '{' && t0.includes('value')) {
    try {
      const o = JSON.parse(t0);
      if (o && typeof o === 'object') {
        if (typeof o.value === 'number' && Number.isFinite(o.value)) return o.value;
        if (o.value && typeof o.value === 'object' && typeof o.value.value === 'number') return o.value.value;
      }
    } catch (_) {}
  }
  const s = t0.replace(/[\s\u00A0_]/g, '');
  if (!s) return NaN;
  if (s.includes('.') && s.includes(',')) {
    if (s.lastIndexOf('.') < s.lastIndexOf(',')) return parseFloat(s.replace(/\./g, '').replace(',', '.')) || NaN;
    return parseFloat(s.replace(/,/g, '')) || NaN;
  }
  if (s.includes(',') && !s.includes('.')) {
    const nComma = s.match(/,/g);
    if (nComma && nComma.length === 1 && /,\d{1,2}$/.test(s)) return parseFloat(s.replace(',', '.')) || NaN;
    if (nComma) return parseFloat(s.replace(/,/g, '')) || NaN;
  }
  return parseFloat(s) || NaN;
}

function isAtOrAbove(v, min, eps = MIN_EPS) {
  return v + eps >= min;
}

function getItems() {
  return document.querySelectorAll('[data-piece-width], [data-piece-length], [data-piece-thickness]');
}

function applyPieceDimensionVisibility() {
  const url = new URL(window.location.href);
  const minW = parseProductDimension(url.searchParams.get(PARAM_W) || '');
  const minL = parseProductDimension(url.searchParams.get(PARAM_L) || '');
  const minT = parseProductDimension(url.searchParams.get(PARAM_T) || '');
  const hasW = Number.isFinite(minW) && minW > 0;
  const hasL = Number.isFinite(minL) && minL > 0;
  const hasT = Number.isFinite(minT) && minT > 0;

  const items = getItems();
  if (!hasW && !hasL && !hasT) {
    items.forEach((item) => { item.hidden = false; item.classList.remove('piece-dimension-filter-hidden'); });
    return;
  }

  items.forEach((item) => {
    const pw = parseProductDimension(item.dataset.pieceWidth);
    const pl = parseProductDimension(item.dataset.pieceLength);
    const pt = parseProductDimension(item.dataset.pieceThickness);
    let hide = false;
    if (hasW && (!Number.isFinite(pw) || !isAtOrAbove(pw, minW))) hide = true;
    if (hasL && (!Number.isFinite(pl) || !isAtOrAbove(pl, minL))) hide = true;
    if (hasT && (!Number.isFinite(pt) || !isAtOrAbove(pt, minT))) hide = true;
    item.hidden = hide;
    item.classList.toggle('piece-dimension-filter-hidden', hide);
  });
}

class PieceDimensionFilter extends HTMLElement {
  getInputs() {
    return {
      w: this.querySelector('[data-dimension-input="w"]'),
      l: this.querySelector('[data-dimension-input="l"]'),
      t: this.querySelector('[data-dimension-input="t"]'),
    };
  }

  setMinParam(url, key, value) {
    if (Number.isFinite(value) && value > 0) url.searchParams.set(key, String(value));
    else url.searchParams.delete(key);
  }

  navigateWithParams(mutator) {
    const url = new URL(window.location.href);
    mutator(url);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  apply = () => {
    const { w, l, t } = this.getInputs();
    this.navigateWithParams((url) => {
      this.setMinParam(url, PARAM_W, parseProductDimension(w?.value || ''));
      this.setMinParam(url, PARAM_L, parseProductDimension(l?.value || ''));
      this.setMinParam(url, PARAM_T, parseProductDimension(t?.value || ''));
    });
  };

  clear = () => {
    this.navigateWithParams((url) => {
      url.searchParams.delete(PARAM_W);
      url.searchParams.delete(PARAM_L);
      url.searchParams.delete(PARAM_T);
    });
  };

  connectedCallback() {
    const url = new URL(window.location.href);
    const { w, l, t } = this.getInputs();
    if (w) w.value = url.searchParams.get(PARAM_W) || '';
    if (l) l.value = url.searchParams.get(PARAM_L) || '';
    if (t) t.value = url.searchParams.get(PARAM_T) || '';
    this.querySelector('[data-dimension-apply]')?.addEventListener('click', this.apply);
    this.querySelector('[data-dimension-clear]')?.addEventListener('click', this.clear);
  }

  disconnectedCallback() {
    this.querySelector('[data-dimension-apply]')?.removeEventListener('click', this.apply);
    this.querySelector('[data-dimension-clear]')?.removeEventListener('click', this.clear);
  }
}

if (!customElements.get('piece-dimension-filter')) customElements.define('piece-dimension-filter', PieceDimensionFilter);

document.addEventListener('DOMContentLoaded', applyPieceDimensionVisibility);
window.addEventListener('popstate', () => requestAnimationFrame(applyPieceDimensionVisibility));

const gridObserver = new MutationObserver(() => requestAnimationFrame(applyPieceDimensionVisibility));
const startObserver = () => {
  const grid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid') || document.body;
  if (grid) gridObserver.observe(grid, { childList: true, subtree: true });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
else startObserver();

applyPieceDimensionVisibility();
